import React from 'react'
import { Text } from "@paro.io/base-ui";
import { IconUser, IconCurrencyDollar } from "@paro.io/base-icons";

import AgreeDisagreeQuestion from '../../../../_global/AgreeDisagreeQuestion';
import ValidatedInput from '../../../../_global/ValidatedInput';


interface BusinessProps {
  setFieldValue: (field: string, value: any, shouldValidate?: boolean) => void
  isFirmProfile: boolean
}

const Business = ({ setFieldValue, isFirmProfile }: BusinessProps) => {
  return (
    <div className="container">
      <AgreeDisagreeQuestion
        title="How will you be setting up your profile?"
        description="Please select Firm only if you have more than one person in your organization. Individual LLC’s should choose 'Individual'."
        status={!isFirmProfile}
        onAgreeClick={() => setFieldValue('isFirmProfile', false, true)}
        onDisagreeClick={() => setFieldValue('isFirmProfile', true, true)}
        buttonProps={[{
          label: "Individual",
          iconLeft: <IconUser size="md" />,
        }, {
          label: "Firm",
          iconLeft: <IconCurrencyDollar size="md" />,
        }]}
      />
      <div >
        <Text className="text-base font-normal">What is the name of your business? {isFirmProfile ? <span className="text-danger">*</span> : <span>(if applicable)</span>}</Text>
        <span className="text-xs text-grey">T&Cs will need to be signed under your business name</span>
        <ValidatedInput placeholder="" name="companyName" type="text" className="mb-3" />
      </div>
    </div>
  )
}

export default Business
